function Currency(val, locale = "nb", currency = "NOK", decimals = 0) {
  if (!val) return;
  return val.toLocaleString(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: decimals,
  });
}

export { Currency };
